import { action } from "satcheljs";

const resetShiftStore = action(
    "RESET_SHIFT_STORE",
    () => ({})
);

export default resetShiftStore;